const drawEllipse = (sprite, width, height) => {
  sprite.drawEllipse(width / 2, height / 2, width / 2, height / 2);
};

export default drawEllipse;
